<template>
    <div>
        <multiselect
                :class="{'active-filter':value.length>0}"
                v-model="internalValue"
                :options="opts"
                group-label="group"
                group-values="options"
                group-select
                multiple
                label="text"
                track-by="value"
                placeholder="Todos"
                taggable>
                <template v-slot:clear v-if="false" >
                    <div class="multiselect__clear" @click="internalValue = []"></div>
                </template>
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
    name:"select-sale-channel-opts",
    props: {
        value: {
            type: Array, 
            default: () => []
        }
    },
    components: {Multiselect},
    data() {
        return {
        };
    },
    computed:{
        internalValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        },
        opts(){
            let groups = [
                {group:'My Sales Channel',options: this.$root.auxVars.salesChannelsOpts},
                {group:'SC Marketplace',options:[{value:'sc',text:"Shuttle Central Marketplace"}]}
            ];

            return groups;
        }
    },
    methods: {
    },
    mounted() {
        this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['salesChannelsOpts']})
    }
};
</script>